import React from 'react'
import { Stack, useTheme } from '@mui/material'

import Checkbox from 'packages/ui/Checkbox'
import Radio from 'packages/ui/Radio'

export const BaseChip = ({label}) => {
  const theme = useTheme()

  return (
    <Stack
      sx={{
        borderRadius: '20px',
        padding: '4px 8px',
        border: `1px solid ${theme.palette.grey[100]}`,
        fontSize: 12
      }}>
      {label}
    </Stack>
  )
}
export const BaseCategoryHeader = ({
  label,
  rightAdornment = null,
  borderColor = null,
  backgroundColor = null,
  color = null,
  onClick = null
}) => {
  const theme = useTheme()
  return (
    <Stack
      onClick={onClick}
      sx={{
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '24px',
        paddingRight: '8px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 500,
        border: `1px solid ${borderColor || theme.palette.grey[100]}`,
        backgroundColor: backgroundColor || theme.palette.grey[50],
        color: color || 'inherit',
        cursor: onClick ? 'pointer' : 'inherit'
      }}>
      <Stack direction="row" alignItems="center" justifyContent={'space-between'}>
        {label}
        {rightAdornment}
      </Stack>
    </Stack>
  )
}

const BaseCategoryItem = ({ onClick, onMouseEnter, onMouseLeave, checked, children }) => {
  const theme = useTheme()
  return (
    <Stack
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        position: 'relative',
        padding: '10px 8px 8px 24px',
        marginLeft: '2px',
        marginRight: '2px',
        fontSize: '12px',
        fontWeight: 500,
        color: checked ? theme.palette.grey[800] : theme.palette.grey[500],
        cursor: 'pointer',
        borderRadius: '8px',
        outline: '2px solid transparent',
        outlineOffset: '0px',
        transition: 'outline-color 0.15s ease-in-out',
        '&:not(:last-child)::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          backgroundColor: theme.palette.grey[100],
          transition: 'opacity 0.15s ease-in-out'
        },
        '&:hover': {
          outlineColor: '#DBE8FE',
          '&::after': {
            opacity: 0
          }
        }
      }}>
      <Stack direction={'row'} alignItems="center" justifyContent={'space-between'}>
        {children}
      </Stack>
    </Stack>
  )
}

export const BaseCategoryItemRadio = ({ label, onClick, checked, onMouseEnter, onMouseLeave }) => {
  return (
    <BaseCategoryItem checked={checked} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {label}
      <Radio
        checked={checked}
        onChange={e => {
          e.stopPropagation()
          onClick()
        }}
      />
    </BaseCategoryItem>
  )
}

export const BaseCategoryItemCheckbox = ({
  label,
  onClick,
  onReadToggle,
  checked,
  checkedSx,
  onMouseEnter,
  onMouseLeave
}) => {
  return (
    <BaseCategoryItem checked={checked} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {label}
      <Checkbox
        checked={checked}
        onChange={e => {
          e.stopPropagation()
          onReadToggle()
        }}
        sx={checkedSx}
      />
    </BaseCategoryItem>
  )
}
